import { SubMenu } from 'constants/SubMenu';
import { ResourceProps } from 'react-admin';
import { CommandCreate } from './CommandCreate';
import { CommandEdit } from './CommandEdit';
import CommandIcon from './CommandIcon';
import { CommandList } from './CommandList';
import { CommandShow } from './CommandShow';

const commands: ResourceProps = {
  name: 'commands',
  list: CommandList,
  //show: ShowGuesser,
  show: CommandShow,
  edit: CommandEdit,
  //edit: EditGuesser,
  create: CommandCreate,
  icon: CommandIcon,
  options: {
    label: 'Unit Commands',
    menu: SubMenu.Develop,
  },
};

export default commands;
